import React, { useState } from 'react';
import { getLanguageFlag } from '../helpers/language_helpers';
import GameStats from './GameStats.jsx';

const GameCard = ({ game, onClick, isAdmin, onEditClick, onCategoryClick, isGroup = false }) => {
  const [imageLoading, setImageLoading] = useState(true);

  const handleEditClick = (e) => {
    e.stopPropagation();
    onEditClick(game.id);
  };

  const handleCategoryTagClick = (e, category) => {
    e.preventDefault();
    e.stopPropagation();
    onCategoryClick(category);
  };

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  if (isGroup) {
    return (
      <article className="game-card" onClick={() => onClick(game)}>
        <div className="card-badges">
          <div className="group-badge" title={`${game.games.length} games in this group`}>
            {game.games.length} games
          </div>
        </div>
        <header className="game-card-header">
          {imageLoading && (
            <div className="spinner-container">
              <div aria-busy="true" className="spinner" />
            </div>
          )}
          <img src={game.image_url} alt={`Box art for ${game.name}`}
               onLoad={handleImageLoad}
               style={{ display: imageLoading ? 'none' : 'block' }} />
        </header>
        <hgroup>
          <GameStats game={game} />
        </hgroup>
      </article>
    );
  }

  const isGrouped = !!game.group_id;

  const expansionsCount = game.expansions_count || 0;

  return (
    <article className="game-card" onClick={() => onClick(game)}>
      <div className="card-badges">
        {game.lent_to && (
          <div className="lent-to-badge" title={`Lent to: ${game.lent_to}`}>
            Lent to: {game.lent_to}
          </div>
        )}
        {expansionsCount > 0 && <div className="expansion-badge" title={`${expansionsCount} expansions`}>+{expansionsCount}</div>}
        {game.language && (
          <div className="language-flag" title={`Language: ${game.language}`}>
            {getLanguageFlag(game.language)}
          </div>
        )}
      </div>
      <header className="game-card-header">
        {imageLoading && (
          <div className="spinner-container">
            <div aria-busy="true" className="spinner" />
          </div>
        )}
        <img src={game.image_url || undefined}
             alt={`Box art for ${game.title}`}
             onLoad={handleImageLoad}
             style={{ display: imageLoading ? 'none' : 'block' }} />
      </header>
      <hgroup>
        <GameStats game={game} />
      </hgroup>
    </article>
  );
};

export default GameCard;
